import { combineReducers } from "@reduxjs/toolkit";
import authSlice from "./slices/auth/authSlice";
import employeeSlice from "./slices/employee/employeeSlice";
import clientSlice from "./slices/client/clientSlice";
import workauthsSlice from "./slices/workauths/workauthsSlice";
import placementsSlice from "./slices/placements/placementsSlice";
import vendorSlice from "./slices/vendor/vendorSlice";
import timesheetSlice from "./slices/timesheets/timsheetSlice";
import totalCountSlice from "./slices/totalCount/totalCountSlice";
import immigrationsSlice from "./slices/immigration/immigrationSlice";
import documentSlice from "./slices/document/documentSlice";
import accountPayablesSlice from "./slices/accountPayables/accountPayablesSlice";
import invoicesSlice from "./slices/invoices/invoicesSlice";
import payrollSlice from "./slices/payroll/payrollSlice";
import quickBooksSlice from "./slices/quickBooks/quickBooksSlice";
import reconciliationSlice from "./slices/reconciliation/reconciliationSlice";
import bdmJobsSlice from "./slices/bdmjobs/bdmjobsSlice";
// import leadReducer from "./slices/MyLeads/leads/leadsSlice";

import leadsSlice from "./slices/leads/leadsSlice";
// import { companyReducer ,searchReducer,leadReducer } from "./slices/leads/leadsSlice";
import accountDetailsSlice from "./slices/accountDetails/accountDetailsSlice";
import compaignsSlice from "./slices/compaigns/compaignsSlice";

import sourcingSlice from "./slices/recruitmentSourcing/SourcingSlice";

import settingSlice from "./slices/setting/settingsSlice";
import signaturesSlice from "./slices/signatures/signaturesSlice";
import internalDbSlice from "./slices/internalDbES/internalDbESlice";
import benchSalesSlice from "./slices/ats/benchSales/benchSalesSlice";
import reportsSlice from "./slices/reports/reportsSlice";
import reportsListSlice from "./slices/reports/reportListSlice";
import bsReportsSlice from "./slices/reports/bsReportsSlice";
import favouriteReportsSlice from "./slices/reports/favouriteReportsSlice";
import wfNotificationSlice from "./slices/wf-notifications/notificationSlice";

import jobsSlice from "./slices/jobs/jobsSlice";
import atsDashboardReducer from "./slices/atsDashboard/atsDashboardSlice";
import buildVersionReducer from "./slices/buildVersion/buildVersionSlice";
import hotlistSlice from "./slices/ats/hotlistSlice";
import incentiveReducer from "./slices/incentives/incentiveSlice";
import ipReducer from "./slices/ip/ipSlice";
import nonitMarketingSlice from "./slices/nonitMarketing/nonitMarketingSlice";
import NMhotlistSlice from "./slices/nonitMarketing/hotlist/hotlistSlice";
import NMjobsSlice from "./slices/nonitMarketing/jobs/jobsSlice";
import nmReportsSlice from "./slices/nonitMarketing/reports/nmReportSlice";
import emaillogsSlice from "./slices/emaillogs/emaillogsSlice";

const rootReducer = combineReducers({
  auth: authSlice,
  employee: employeeSlice,
  client: clientSlice,
  workauth: workauthsSlice,
  vendor: vendorSlice,
  placement: placementsSlice,
  timesheet: timesheetSlice,
  totalCount: totalCountSlice,
  immigration: immigrationsSlice,
  documents: documentSlice,
  accountPayables: accountPayablesSlice,
  invoices: invoicesSlice,
  payRoll: payrollSlice,
  quickBooks: quickBooksSlice,
  reconciliation: reconciliationSlice,
  wfNotification: wfNotificationSlice,
  // search : searchReducer,
  // company : companyReducer,
  //  leads : leadReducer,
  leads: leadsSlice,
  accountDetails: accountDetailsSlice,
  bdmJobs: bdmJobsSlice,
  compaigns: compaignsSlice,
  sourcing: sourcingSlice,
  settings: settingSlice,
  internalDbES: internalDbSlice,
  signatures: signaturesSlice,
  benchsales: benchSalesSlice,
  reports: reportsSlice,
  reportsList: reportsListSlice,
  favouriteReports: favouriteReportsSlice,
  bsReports: bsReportsSlice,
  nmReports: nmReportsSlice,
  nonitMarketing: nonitMarketingSlice,
  jobs: jobsSlice,
  atsDashboard: atsDashboardReducer,
  buildVersion: buildVersionReducer,
  hotlist: hotlistSlice,
  incentive: incentiveReducer,
  ip: ipReducer,
  NMhotlist: NMhotlistSlice,
  NMjobs: NMjobsSlice,
  emaillogs: emaillogsSlice,
});

// export default rootReducer;
// Global reset action
const appReducer = (state, action) => {
  if (action.type === "RESET_STORE") {
    state = undefined; // This resets the entire state to initial values
  }
  return rootReducer(state, action); // Proceed to the original reducer logic
};

export default appReducer;
